import { DataService } from "../../services/data.service";
import { BusinesLogicService } from "../../services/business-logic.service";
import { ModalHelper } from "../../components/modal/modal.helper";
import { NotificationService } from "../../services/notification.service";
import { LanguagePipe } from "../../services/language.pipe";
import { DeskMessage } from "../../models/deskmessage.model";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ChatService } from "../../services/chat.service";
var MessageComponent = (function () {
    function MessageComponent(_data, _blogic, _notify, _lang, _modal, _chat) {
        this._data = _data;
        this._blogic = _blogic;
        this._notify = _notify;
        this._lang = _lang;
        this._modal = _modal;
        this._chat = _chat;
        this.status = 0; /* 0 = Enviar, 1 = Enviando..., 2 = Enviado */
        this.notifyCounter = 0;
        this.messages = [];
        this.alerts = [];
        this.messagesAlert = [];
        this.message = {};
        this.loadingSocket = false;
        this.actualConversation = null;
        this.actualConversationMessages = [];
        this.conversations = [];
        this.showGlobalMessages = false;
        this.globalMessageOffices = [];
        this.globalMessageOfficeSelected = null;
        this.globalMessageDesks = [];
        this.globalMessage = "";
        this.globalMessageOk = false;
        this.destroy$ = new Subject();
    }
    MessageComponent.prototype.ngOnInit = function () {
        this.parseDesks(); /* Parseo de mesas con el chat activado */
        this.parseDesks("alert"); /* Parseo de mesas con el botón de emergencia activado */
        this.initIoConnection();
        this.globalMessageOfficeSelected = this._data.session["office"];
        this.globalMessageOffices = this._data.offices;
        this.getGlobalMessageDesks();
        this._blogic.getOnlineList();
    };
    MessageComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    // Initialize SocketConnection
    MessageComponent.prototype.initIoConnection = function () {
        var _this = this;
        if (!this.loadingSocket) {
            this.loadingSocket = true;
            if (this.subscriptionClose != null)
                this.subscriptionClose.unsubscribe();
            if (this.subscriptionOpen != null)
                this.subscriptionOpen.unsubscribe();
            if (this.ioConnection != null)
                this.ioConnection.unsubscribe();
            this._chat.close();
            this._chat.open();
            this.ioConnection = this._chat.onMessage()
                .subscribe(function (message) {
                if (message.type == "alert") {
                    if (message["from"] != _this._data.session["desk"]) {
                        _this.alerts.push(message);
                        _this.messages.push(message);
                        _this.notify();
                    }
                }
                else {
                    if (message.to != 'all') {
                        if (message.msg == "readed!246810readed!") {
                            _this.markConversationAsRead(message.from);
                        }
                        else {
                            _this.conversations.push({ chatWith: message.from, msg: message.msg, hour: _this.getTime(), messageByMe: false, readed: false, readedByMe: false });
                            _this.getConversation(message.from, false);
                            _this.messages.push(message);
                            _this.notify();
                            if (_this.actualConversation != null && message.from == _this.actualConversation["id"]) {
                                _this.send(false, true);
                                _this.markConversationAsRead(_this.actualConversation["id"]);
                                _this.markMyNotificationsAsRead(_this.actualConversation["id"]);
                            }
                        }
                    }
                    else {
                        _this.messagesAlert.push(message);
                        if (_this.notifyCounter == 0)
                            _this.notifyAlarm();
                    }
                }
            });
            this.subscriptionOpen = this._chat.onOpen()
                .subscribe(function (response) {
                _this.loadingSocket = false;
            });
            this.subscriptionClose = this._chat.onClose()
                .subscribe(function (response) {
                setTimeout(function () {
                    _this._chat.close();
                    _this.loadingSocket = false;
                    _this.initIoConnection();
                }, 15000);
            });
        }
    };
    /* Open the messages modal */
    MessageComponent.prototype.openSendModal = function (from, content) {
        var _this = this;
        if (from === void 0) { from = null; }
        if (content === void 0) { content = null; }
        if (from != null && content != null) {
            this.messageForm["to"] = from;
            this.messageForm["content"] = content;
            //this.markAsRead();
        }
        else {
            this.messageForm = {};
        }
        this._blogic.deskOnline()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.onlineDesks = response;
            _this._modal.show("sendModal");
            var self = _this;
            $('#sendModal').on('hidden.bs.modal', function (e) {
                self.actualConversation = null;
            });
        });
    };
    MessageComponent.prototype.lastMessage = function (id) {
        var lastMessage = null;
        this.conversations.forEach(function (e) {
            if (id == e.chatWith)
                lastMessage = e;
        });
        return lastMessage;
    };
    MessageComponent.prototype.openAlertModal = function () {
        this._modal.show("questionAlertModal");
    };
    MessageComponent.prototype.getCountNotifications = function (id) {
        var count = 0;
        this.conversations.forEach(function (e) {
            if ((id == e.chatWith) && (e.messageByMe == false) && (e.readedByMe == false)) {
                count++;
            }
        });
        return count;
    };
    MessageComponent.prototype.getCountAllNotifications = function () {
        var count = 0;
        this.conversations.forEach(function (e) {
            if ((e.messageByMe == false) && (e.readedByMe == false)) {
                count++;
            }
        });
        count = count + this.alerts.length;
        return count;
    };
    MessageComponent.prototype.deleteAlert = function (i) {
        this.alerts.splice(i, 1);
    };
    MessageComponent.prototype.parseDesks = function (mode) {
        var _this = this;
        if (mode === void 0) { mode = "chat"; }
        var desks = [];
        this._blogic.getChatList()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.desks.forEach(function (e) {
                if (mode == "chat") {
                    if (response.chat.indexOf(e.id) != -1 && e.id != _this._data.session["desk"]) {
                        desks.push(e);
                    }
                }
                else {
                    if (response.alert.indexOf(e.id) != -1 && e.id != _this._data.session["desk"]) {
                        desks.push(e);
                    }
                }
            });
        });
        if (mode == "chat") {
            this.chatDesks = desks;
        }
        else {
            this.alertDesks = desks;
        }
    };
    MessageComponent.prototype.getDesksAvailables = function () {
        var _this = this;
        var availableDesks = [];
        this.chatDesks.forEach(function (e) {
            if (_this._blogic.isDeskOnline(e.id))
                availableDesks.push(e);
        });
        availableDesks = availableDesks.sort(function (a, b) {
            return a["id"] - b["id"];
        });
        return availableDesks;
    };
    MessageComponent.prototype.send = function (alert, readedAlert) {
        var _this = this;
        if (alert === void 0) { alert = false; }
        if (readedAlert === void 0) { readedAlert = false; }
        if ((this.messageForm && this.messageForm["content"] && this.messageForm["content"].replace(/ /g, "").length > 0) || readedAlert == true || alert) {
            this.status = 1;
            this.message = new DeskMessage();
            if (alert) {
                this.message["to"] = 'all';
                this.message["msg"] = this._data.configuration["alertMessage"];
            }
            else {
                this.message["to"] = this.actualConversation["id"];
                this.message["msg"] = this.messageForm["content"];
                if (!readedAlert) {
                    this.conversations.push({ chatWith: this.actualConversation["id"], msg: this.message["msg"], hour: this.getTime(), messageByMe: true, readed: false, readedByMe: true });
                    this.getConversation(this.actualConversation["id"]);
                }
            }
            this.message["from"] = this._data.session["desk"];
            this.message["from_name"] = this._data.session["deskname"];
            if (readedAlert)
                this.message["msg"] = "readed!246810readed!";
            this._chat.sendMessage(this.message);
            if (!readedAlert)
                this.messageForm = {};
            this.status = 2;
            setTimeout(function () {
                _this.status = 0;
                if (alert)
                    _this._modal.hide("questionAlertModal");
            }, 1500);
        }
    };
    MessageComponent.prototype.sendGlobalMessage = function () {
        var _this = this;
        this.globalMessageDesks.forEach(function (e) {
            if (e["checked"] == true) {
                var message = new DeskMessage();
                message["to"] = e["id"];
                message["msg"] = _this.globalMessage;
                message["from"] = _this._data.session["desk"];
                message["from_name"] = _this._data.session["deskname"];
                message["office_name"] = _this._data.session["officename"];
                message["hour"] = _this.getTime();
                message["type"] = "alert";
                _this._chat.sendMessage(message);
                _this.globalMessageOk = true;
                setTimeout(function () {
                    _this.globalMessageOk = false;
                }, 2000);
            }
        });
        this.globalMessage = "";
    };
    MessageComponent.prototype.getConversation = function (id, showInView) {
        if (showInView === void 0) { showInView = true; }
        if (id == null)
            return;
        var conversation = [];
        this.conversations.forEach(function (e) {
            if (e.chatWith == id) {
                conversation.push(e);
            }
        });
        if (this.actualConversation && this.actualConversation["id"] == id)
            this.actualConversationMessages = conversation;
        setTimeout(function () {
            var d = $('#chat-view');
            d.scrollTop(d.prop("scrollHeight"));
        }, 50);
    };
    // Envía que he leído la conversación actual
    MessageComponent.prototype.readConversation = function () {
        this.send(false, true);
    };
    MessageComponent.prototype.sendAlert = function () {
        this.send(true);
    };
    MessageComponent.prototype.notifyAlarm = function () {
        this.message = this.messagesAlert.shift();
        $(".modal").modal("hide");
        this._modal.show("receivedModal", false);
        if (this._notify.hasPermission() && this.notifyCounter == 0) {
            this._notify.notify(this._lang.transform("notifyEmergency") +
                this.message["from"], this.message["msg"], "alarm.gif");
        }
        this.notifyCounter++;
    };
    MessageComponent.prototype.notify = function () {
        this.message = this.messages.shift();
        if (this._notify.hasPermission()) {
            this._notify.notify(this._lang.transform("notifyNewMessage") +
                this.message["from_name"], this.message["msg"], "chat_notification.png");
        }
    };
    MessageComponent.prototype.markConversationAsRead = function (id) {
        this.conversations.forEach(function (e) {
            if (e.chatWith == id) {
                e.readed = true;
            }
        });
    };
    MessageComponent.prototype.markMyNotificationsAsRead = function (id) {
        this.conversations.forEach(function (e) {
            if (e.chatWith == id) {
                e.readedByMe = true;
            }
        });
    };
    MessageComponent.prototype.markAsRead = function () {
        this._modal.hide("receivedModal");
        this.notifyCounter = 0;
        if (this.messagesAlert.length > 0)
            this.notifyAlarm();
        else if (this.messages.length > 0)
            this.notify();
    };
    MessageComponent.prototype.openConversation = function (d) {
        this.actualConversation = d;
        this.getConversation(d.id);
        //this.markConversationAsRead(d.id); // Envío a la otra persona que he leído sus mensajes
        this.markMyNotificationsAsRead(d.id); // Indico como leída la conversación para que no me aparezca como notificación
        this.readConversation();
    };
    MessageComponent.prototype.checkTime = function (i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    };
    MessageComponent.prototype.getTime = function () {
        var today = new Date();
        var h = today.getHours();
        var m = today.getMinutes();
        var s = today.getSeconds();
        // add a zero in front of numbers<10
        m = this.checkTime(m);
        s = this.checkTime(s);
        return h + ":" + m;
    };
    MessageComponent.prototype.getGlobalMessageDesks = function () {
        var _this = this;
        this._blogic.listDesk({ office_id: this.globalMessageOfficeSelected })
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.globalMessageDesks = response.filter(function (e) { return e.visible == true; });
            _this.globalMessageDesks.map(function (e) { return e["checked"] = true; });
        });
    };
    MessageComponent.prototype.checkAllGlobalDesks = function () {
        this.globalMessageDesks.map(function (e) { return e["checked"] = true; });
    };
    MessageComponent.prototype.unCheckAllGlobalDesks = function () {
        this.globalMessageDesks.map(function (e) { return e["checked"] = false; });
    };
    return MessageComponent;
}());
export { MessageComponent };
